import React from 'react';
import './ChatHomeComponents.css';
import card1 from '../../assets/images/card_1.svg';
import card2 from '../../assets/images/card_2.svg';
import card3 from '../../assets/images/card_3.svg';
import card4 from '../../assets/images/card_4.svg';
import card5 from '../../assets/images/card_5.svg';

const FAQ_CARDS = [
  { image: card5, color: '#4C28A9' },
  { image: card4, color: '#B21769' },
  { image: card2, color: '#0D4BB0' },
  { image: card3, color: '#008685' },
  { image: card1, color: '#995E00' },
];

/**
 * FAQSection Component
 * Displays a grid of frequently asked question cards
 * 
 * @param {Object} props
 * @param {Array} props.faqItems - Array of FAQ objects with {question, color}
 * @param {Function} props.onQuestionClick - Callback when FAQ is clicked
 * @param {string} props.title - Title for the FAQ section (default: "Frequently Asked Questions (FAQs)")
 */
const FAQSection = ({ 
  faqItems = [], 
  onQuestionClick, 
  title = "Frequently Asked Questions (FAQs)" 
}) => {
  return (
    <div className="faq-section" role="region" aria-label="Frequently Asked Questions">
      <h2 className="faq-title">
        {title}
      </h2>
      <div className="faq-scroll" role="list">
        {faqItems.map((faq, idx) => (
          <button
            key={idx}
            type="button"
            role="listitem"
            onClick={() => onQuestionClick?.(faq.question)}
            className="faqlink"
            aria-label={`Ask: ${faq.question}`}
            style={{
              backgroundColor: FAQ_CARDS[idx % FAQ_CARDS.length].color,
            }}
          >
            <img
              src={FAQ_CARDS[idx % FAQ_CARDS.length].image}
              alt=""
              aria-hidden="true"
              className="faq-card-background"
            />
            <span className="faq-card-text">
              {faq.question}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default FAQSection;
